import { render, staticRenderFns } from "./WeeklyConsumption.vue?vue&type=template&id=4b5a8d9d&scoped=true&"
import script from "./WeeklyConsumption.vue?vue&type=script&lang=ts&"
export * from "./WeeklyConsumption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a8d9d",
  null
  
)

export default component.exports